import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import Nlayout from './Nlayout';
import './Rankings.css';
import { FaRegCalendarAlt, FaChevronRight, FaSearch } from 'react-icons/fa';

export default function ListadoRankings() {
    const [rankingsList, setRankingsList] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');

    const obtenerRankings = async () => {
        try {
            setLoading(true);
            const res = await axios.get('https://backend.eldenguee.com/torneo/ranking');
            // Support both direct array response and object responses (e.g., recordset, data, rankings)
            const data = Array.isArray(res.data)
                ? res.data
                : (res.data?.recordset || res.data?.rankings || res.data?.data || []);
            setRankingsList(data);
        } catch (error) {
            console.error('Error al obtener todos los rankings:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        obtenerRankings();
    }, []);

    const formatFecha = (item) => {
        const fechaRaw = item.fecha || item.fecha_creacion || item.createdAt;
        if (!fechaRaw) return `Ranking #${item.id || item._id || 'Desconocido'}`;
        try {
            const date = new Date(fechaRaw);
            if (isNaN(date.getTime())) return fechaRaw;
            return date.toLocaleDateString('es-ES', {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
            });
        } catch (e) {
            return fechaRaw;
        }
    };

    const rankingsFiltrados = rankingsList.filter(item => {
        const idStr = String(item.id || item._id || '').toLowerCase();
        const fechaStr = formatFecha(item).toLowerCase();
        const term = searchTerm.toLowerCase();
        return idStr.includes(term) || fechaStr.includes(term);
    });

    return (
        <Nlayout>
            <div className="rankings-container">
                <div className="rankings-content">
                    <div className="admin-rankings-title-row">
                        <div>
                            <h1 className="rankings-title">Listado de Rankings</h1>

                        </div>
                    </div>

                    <div className="rankings-controls" style={{ marginBottom: '30px' }}>
                        <div style={{ position: 'relative', flexGrow: 1, display: 'flex', alignItems: 'center' }}>
                            <input
                                type="text"
                                className="rankings-search-input"
                                placeholder="Buscar por fecha o ID del ranking..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                style={{ paddingLeft: '45px' }}
                            />
                            <FaSearch style={{ position: 'absolute', left: '18px', color: 'rgba(255,255,255,0.3)' }} />
                        </div>
                        <button className="rankings-refresh-btn" onClick={obtenerRankings}>
                            Actualizar Lista
                        </button>
                    </div>

                    {loading ? (
                        <div style={{ display: 'flex', justifyContent: 'center', padding: '60px 0' }}>
                            <div className="loader-spinner" style={{
                                width: '40px',
                                height: '40px',
                                border: '4px solid rgba(255, 255, 255, 0.1)',
                                borderTop: '4px solid #807ffb',
                                borderRadius: '50%',
                                animation: 'spin 1s linear infinite'
                            }} />
                            <style>{`
                                @keyframes spin {
                                    0% { transform: rotate(0deg); }
                                    100% { transform: rotate(360deg); }
                                }
                            `}</style>
                        </div>
                    ) : rankingsFiltrados.length === 0 ? (
                        <div className="rankings-rules-card" style={{ textAlign: 'center', padding: '50px 20px' }}>
                            <p style={{ color: 'rgba(255,255,255,0.4)', fontSize: '1.2rem', margin: 0 }}>
                                {searchTerm ? 'No se encontraron rankings que coincidan con la búsqueda.' : 'No hay rankings registrados aún.'}
                            </p>
                        </div>
                    ) : (
                        <div className="rankings-table-container">
                            <table className="rankings-table">
                                <thead>
                                    <tr>
                                        <th>Fecha del Stream</th>
                                        <th>ID del Ranking</th>
                                        <th>Estado</th>
                                        <th style={{ textAlign: 'right' }}>Acciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {rankingsFiltrados.map((item, index) => {
                                        const rankingId = item.id || item._id;
                                        // Assume the first one (index 0) is the latest/active one, or check if active is explicitly true
                                        const isActive = index === 0 || item.activo === true || item.estado === 'activo';

                                        return (
                                            <tr key={rankingId}>
                                                <td>
                                                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                                        <FaRegCalendarAlt style={{ color: '#807ffb' }} />
                                                        <span style={{ fontWeight: 600 }}>{formatFecha(item)}</span>
                                                    </div>
                                                </td>
                                                <td style={{ fontFamily: 'monospace', color: 'rgba(255,255,255,0.6)' }}>
                                                    {rankingId}
                                                </td>
                                                <td>
                                                    <span className={`ranking-badge-status ${isActive ? 'active' : 'archived'}`}>
                                                        {isActive ? 'Último Directo' : 'Archivado'}
                                                    </span>
                                                </td>
                                                <td style={{ textAlign: 'right' }}>
                                                    <Link to={`/ranking/${rankingId}`} className="btn-action-view">
                                                        Ver Detalle <FaChevronRight style={{ marginLeft: '6px', fontSize: '0.8rem' }} />
                                                    </Link>
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            </div>
        </Nlayout>
    );
}
